import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row g-5 g-xl-8" }
const _hoisted_2 = { class: "col-xl-6" }
const _hoisted_3 = { class: "col-xl-6" }
const _hoisted_4 = { class: "row g-5 g-xl-8" }
const _hoisted_5 = { class: "col-xl-6" }
const _hoisted_6 = { class: "col-xl-6" }
const _hoisted_7 = { class: "row g-5 g-xl-8" }
const _hoisted_8 = { class: "col-xl-6" }
const _hoisted_9 = { class: "col-xl-6" }
const _hoisted_10 = { class: "row g-5 g-xl-8" }
const _hoisted_11 = { class: "col-xl-6" }
const _hoisted_12 = { class: "col-xl-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ChartsWidget1 = _resolveComponent("ChartsWidget1")
  const _component_ChartsWidget2 = _resolveComponent("ChartsWidget2")
  const _component_ChartsWidget3 = _resolveComponent("ChartsWidget3")
  const _component_ChartsWidget4 = _resolveComponent("ChartsWidget4")
  const _component_ChartsWidget5 = _resolveComponent("ChartsWidget5")
  const _component_ChartsWidget6 = _resolveComponent("ChartsWidget6")
  const _component_ChartsWidget7 = _resolveComponent("ChartsWidget7")
  const _component_ChartsWidget8 = _resolveComponent("ChartsWidget8")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_ChartsWidget1, { "widget-classes": "card-xl-stretch mb-xl-8" })
      ]),
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_ChartsWidget2, { "widget-classes": "card-xl-stretch mb-xl-8" })
      ])
    ]),
    _createVNode("div", _hoisted_4, [
      _createVNode("div", _hoisted_5, [
        _createVNode(_component_ChartsWidget3, { "widget-classes": "card-xl-stretch mb-xl-8" })
      ]),
      _createVNode("div", _hoisted_6, [
        _createVNode(_component_ChartsWidget4, { "widget-classes": "card-xl-stretch mb-xl-8" })
      ])
    ]),
    _createVNode("div", _hoisted_7, [
      _createVNode("div", _hoisted_8, [
        _createVNode(_component_ChartsWidget5, { "widget-classes": "card-xl-stretch mb-xl-8" })
      ]),
      _createVNode("div", _hoisted_9, [
        _createVNode(_component_ChartsWidget6, { "widget-classes": "card-xl-stretch mb-xl-8" })
      ])
    ]),
    _createVNode("div", _hoisted_10, [
      _createVNode("div", _hoisted_11, [
        _createVNode(_component_ChartsWidget7, { "widget-classes": "card-xl-stretch mb-xl-8" })
      ]),
      _createVNode("div", _hoisted_12, [
        _createVNode(_component_ChartsWidget8, { "widget-classes": "card-xl-stretch mb-xl-8" })
      ])
    ])
  ], 64))
}